import React, { useContext } from 'react'
import { Button } from 'semantic-ui-react'

import SessionContext from 'context/SessionContext'

export default function ActionButton(props) {
  const session = useContext(SessionContext)

  const _props = { ...props }
  delete _props.staticContext

  if (props.can && session.can(props.can)) {
    return <Button {..._props} />
  }

  return null
}
